import React, { Component } from 'react';
import { connect } from 'react-redux';
/*import { ConnectedRouter } from 'react-router-redux'*/
import { Router } from 'react-router';
import { inject, observer } from 'mobx-react'
// import { history,stores } from "../history_mobx";
import { Switch, Route } from "react-router-dom";
import MobileWrapper from './MobileWrapper.jsx';
import axios from "../utils/axios";
import { withRouter } from 'react-router';
/*import ScrollMemory from 'react-router-scroll-memory';*/
import ScrollMemory from '../utils/react-router-scroll-memory/src/ScrollMemory';
import qs from 'qs';
import fetchTranslate from '../actions/fetchTranslate';
import setWebpSupport from '../actions/setWebpSupport';
import setGridMode from '../actions/setGridMode';
import fetchMe from '../actions/fetchMe';
import setVisibility from '../actions/setVisibility';
import Loading from './Loading.jsx';
import Footer from './Footer.jsx';
import Errors from './Helpers/GlobalErrors/Errors';

//async
import asyncComponent from './AsyncComponent';

//pages


//popups

//import MarketInfoEdit from './Market/InfoEdit';

//global
import ChatContacts from './Chat/ChatContacts';
import ChatWindows from './Chat/ChatWindows';
import WebSockets from './WebSockets';
import PopupCompositor from './Popups/PopupCompositor';

//tooltip
import 'react-tippy/dist/tippy.css'
import { configure } from "mobx"
//

//evablocks

//import FiguresWrapper from './Wrappers/Figures.jsx';
const FiguresWrapper = asyncComponent(()=> import('./Wrappers/Figures.jsx'));
const BlogWrapper = asyncComponent(()=> import('./Wrappers/Blog.jsx'));
const ChatWrapper = asyncComponent(()=> import('./Wrappers/ChatWrapper.jsx'));
const PhotospotWrapper = asyncComponent(()=> import('./Wrappers/Photospot.jsx'));
const MainPageWrapper = asyncComponent(()=> import('./Wrappers/MainPage.jsx'));
const AnimeWrapper = asyncComponent(()=> import('./Wrappers/Anime.jsx'));
const CharactersWrapper = asyncComponent(()=> import('./Wrappers/Characters.jsx'));
const UsersWrapper = asyncComponent(()=> import('./Wrappers/Users.jsx'));
const MarketWrapper = asyncComponent(()=> import('./Wrappers/Market.jsx'));
const ProfileWrapper = asyncComponent(()=> import('./Wrappers/Profile.jsx'));
const ModerationWrapper = asyncComponent(()=> import('./Wrappers/Moderation.jsx'));


const Blog = asyncComponent(()=> import('./Blog/Blog.jsx'));
const BlogDetail = asyncComponent(()=> import('./Blog/Detail.jsx'));
const HomePage = asyncComponent(()=> import('./HomePage/HomePage.jsx'));
const NotFound = asyncComponent(()=> import('./NotFound.jsx'));

const FiguresDetail = asyncComponent(()=> import('./Figures/Detail.jsx'));
const AnimeDetail = asyncComponent(()=> import('./Anime/Detail.jsx'));
const CharacterDetail = asyncComponent(()=> import('./Characters/Detail.jsx'));

const UserRegister = asyncComponent(()=> import('./User/Register.jsx'));
const UserAuth = asyncComponent(()=> import('./User/Auth.jsx'));
const UserConfirm = asyncComponent(()=> import('./User/Confirm.jsx'));
const UserForgot = asyncComponent(()=> import('./User/Forgot.jsx'));

const PhotospotDetail = asyncComponent(()=> import('./Photospot/Detail.jsx'));
const PhotosPopupEdit = asyncComponent(()=> import('./Shelf/UploadPhotos/PhotosPopupEdit.jsx'));

const PhotoPopupDetail = asyncComponent(()=> import('./Photospot/PopupDetail.jsx'));
const StoreOrderDetail = asyncComponent(()=> import('./Market/StoreOrderDetail'));
const FigureFormEdit = asyncComponent(()=> import('./Figures/Form/FigureFormEdit'));

// const LastCommentsWithStore = asyncComponent(()=> import('./Comments/LastCommentsWithStore'));
const CommentsWrapper = asyncComponent(()=> import('./Comments/CommentsWrapper'));
const SpyingWrapper = asyncComponent(()=> import('./Spying/SpyingWrapper'));



configure({
    enforceActions: "never",
});


class MyAnimeShelf extends Component {
  /*constructor(props) {
    super(props);
    this.state={
      mas:null
    }
  }*/
  constructor(props) {
    super(props);

    this._onResize = (e) => {
      let mode = '';
      if (e.target.innerWidth <= 767) {
        mode = 's';
      }
      if (e.target.innerWidth >= 768 && e.target.innerWidth <= 1023) {
        mode = 'm';
      }
      if (e.target.innerWidth >= 1024) {
        mode = 'h';
      }
      if (e.target.innerWidth >= 1300) {
        mode = 'xl';
      }

      this.props.appStateStore.grid_mode=mode;
    };
    this._onVisibilityChange=()=>{
      console.log('_onVisibilityChange',document.hidden, this.props.appStateStore.app_visible);
      if(document.hidden) {

        if(this.props.appStateStore.app_visible === document.hidden) {
          this.props.appStateStore.app_visible=false;
          // this.props.setVisibility(false);
        }
      } else {
        if(this.props.appStateStore.app_visible === document.hidden) {
          this.props.appStateStore.app_visible=true;
          // this.props.setVisibility(true);
        }
      }
      //visibilitychange
    };
  }

  componentDidMount() {

    const supportsWebP = (function () {
      'use strict';

      var index = new Promise(function (resolve) {
        var image = new Image();
        image.onerror = function () {
          return resolve(false);
        };
        image.onload = function () {
          return resolve(image.width === 1);
        };
        image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
      }).catch(function () {
        return false;
      });

      return index;

    }());

    supportsWebP.then((data)=>{
      //console.log("webp support:",data);
      this.props.appStateStore.webp_support=true;
    });

    window.addEventListener('resize', this._onResize);
    document.addEventListener('visibilitychange', this._onVisibilityChange);
    this._onResize({target: window});
    this._onVisibilityChange();
  }
  componentWillUnmount() {
    window.removeEventListener('resize',this._onResize);
    document.removeEventListener('visibilitychange', this._onVisibilityChange);
  }

  componentWillMount() {
    this.props.translateStore.fetchTranslate();
    this.props.meStore.fetchMe();
  }
  getPopupPath() {
    if(this.props.router.location) {
      const parsed = qs.parse(this.props.router.location.search, {ignoreQueryPrefix: true});
      if (parsed.popup) {
        return parsed.popup;
      }
    }
    return '/';
  }

  renderPopup(path) {
    const ex=path.split('/');

    if(ex[1]=='user_order') {
      return (
        <StoreOrderDetail id={ex[3]} user_nick={ex[2]} userMode={true}/>
      )
    }
    if(ex[1]=='store_order') {
      return (
        <StoreOrderDetail id={ex[3]} user_nick={ex[2]}/>
      )
    }
    if(ex[1]=='photos') {
      return (
        <PhotoPopupDetail id={ex[2]} />
      )
    }
    if(ex[1]=='editphotos') {
      const photos = ex[2].split(',');
      return (
        <PhotosPopupEdit ids={photos} />
      )
    }

    if(ex[1]=='user') {
      if(ex[2]=='register') {
        return (
          <UserRegister />
        )
      }
      if(ex[2]=='confirm') {
        return (
          <UserConfirm />
        )
      }
      if(ex[2]=='auth') {
        return (
          <UserAuth />
        )
      }
      if(ex[2]=='forgot') {
        return (
          <UserForgot />
        )
      }
    }
    return null;
  }

  needScrollMemory(popup) {
    if(this._lastCheck===window.location.search) {
      if(typeof this._wasSave !== 'undefined') {
        console.log('return '+(this._wasSave?'true':'false')+' was save '+window.location.search);
        return this._wasSave;
      }
      console.log('return false not was save '+window.location.search);
      return false;
    }
    this._lastCheck=window.location.search;
    const parsed = qs.parse(window.location.search, {ignoreQueryPrefix: true});
    for(let i in parsed) {
      if(i.indexOf('popup')>-1) {
        this._wasSave=false;
        console.log('return false not was save '+window.location.search);
        return false;
      }
    }
    this._wasSave=true;
    console.log('return true not was save '+window.location.search);
    return true;
  }
  render() {
    console.log('render main');
    if(!this.props.translateStore.translate.inited || !this.props.meStore.me.inited || this.props.appStateStore.webp_support === null) {
      return (
        <Loading />
      )
    }

    const popup=this.getPopupPath();
    let context={};
    return (
      <div className={` ${this.props.appStateStore.site_tpl?`tpl_${this.props.appStateStore.site_tpl}`:''}`}>

          <div>

            <MobileWrapper>
              <Switch>
                <Route path="/profile/" component={ProfileWrapper} />
                <Route path="/chat/" component={ChatWrapper} />

                {/*

                <Route exact path="/blog/drafts" component={BlogWrapper} />
                <Route exact path="/blog/edit/:id?" component={BlogWrapper} />
                <Route exact path="/blog/:id/comments" render={(props)=>{ return ( <BlogDetail {...props} comments_mode={true} /> ); } } />
                <Route exact path="/blog/:id" component={BlogDetail} />
                <Route exact path="/blog/:nick" component={Blog} />
                */}
                <Route exact path="/blog/drafts" component={BlogWrapper} />
                <Route exact path="/blog/my" component={BlogWrapper} />
                <Route exact path="/blog/" component={BlogWrapper} />

                <Route exact path="/figures/" component={FiguresWrapper} />
                <Route path="/last_comments/" component={CommentsWrapper} />
                <Route path="/spying/" component={SpyingWrapper} />

                {/*


                <Route exact path="/figures/wishlist" component={FiguresWrapper} />
                <Route exact path="/figures/preorder" component={FiguresWrapper} />
                <Route exact path="/figures/add" component={FiguresWrapper} />
                <Route exact path="/figures/my" component={FiguresWrapper} />
                <Route exact path="/figures/:id/edit" component={FigureFormEdit} />
                <Route exact path="/figures/:id/comments" render={(props)=>{ return ( <FiguresDetail {...props} comments_mode={true} /> ); } } />
                <Route exact path="/figures/:id" component={FiguresDetail} />
                <Route exact path="/figures/" component={FiguresWrapper} />

                <Route exact path="/moderation/" component={ModerationWrapper} />
                <Route exact path="/moderation/figures/" component={ModerationWrapper} />
                <Route exact path="/moderation/figures/:id" component={ModerationWrapper} />

                <Route path="/anime/my/" component={AnimeWrapper} />
                <Route exact path="/anime/:id/comments" render={(props)=>{ return ( <AnimeDetail {...props} comments_mode={true} /> ); } } />
                <Route exact path="/anime/:id" component={AnimeDetail} />
                <Route path="/anime/" component={AnimeWrapper} />


                <Route exact path="/characters/:id" component={CharacterDetail} />

                <Route exact path="/characters/" component={CharactersWrapper} />

                <Route path="/shelf/" component={UsersWrapper} />


                <Route path="/market/:var1?/:var2?" component={MarketWrapper} />

                <Route path="/photospot/my" component={PhotospotWrapper} />
                <Route exact path="/photospot/:id/comments" render={(props)=>{ return ( <PhotospotDetail {...props} comments_mode={true} /> ); } } />
                <Route exact path="/photospot/" component={PhotospotWrapper} />
                <Route exact path="/" component={HomePage} />

                */}
                <Route exact path="/photospot/" component={PhotospotWrapper} />
                <Route exact path="/" component={MainPageWrapper} />
                <Route path="*" component={NotFound} />
              </Switch>

              {/*
              <ScrollMemory needScroll={(next,actual)=>{
                console.log('needScroll',next,actual);

                const parsedNext = qs.parse(next.search, {ignoreQueryPrefix: true});
                const parsedActual = qs.parse(actual.search, {ignoreQueryPrefix: true});

                for(let i in parsedNext) {
                  if(i.indexOf('popup')>-1) {
                    return false;
                  }
                }
                for(let i in parsedActual) {
                  if(i.indexOf('popup')>-1) {
                    return false;
                  }
                }
                if(parsedNext.page!==parsedActual.page || next.pathname!==actual.pathname) {
                  return true;
                }

                return false;
              }} />
            */}
            </MobileWrapper>
            {this.renderPopup(popup)}
            <Errors />
            {/*

            <Footer />
            <PopupCompositor />
            */}
            <ChatContacts popupMode={true} />
            <ChatWindows />
            <WebSockets />
          </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    router:state.router,
    translate:state.translate,
    me:state.me,
    site_options:state.site_options,
    grid_mode:state.grid_mode,
    app_visible:state.app_visible,
    webp:state.webp,

  }
}

//export default MyAnimeShelf;
export default withRouter(inject("translateStore","meStore","appStateStore","router")(observer(MyAnimeShelf)));
// export default connect(mapStateToProps, { fetchTranslate,fetchMe, setGridMode, setVisibility, setWebpSupport }, null, { pure: false })(MyAnimeShelf);
